import { useState, useEffect } from 'react';
import PulseDot from '@/components/atoms/PulseDot';
import api from '@/lib/api';

// Status ticker — fallback messages. Each must be a claim we can DEFEND under
// buyer-DD. Audited 2026-06-22 (M10) — stripped 3 unsupportable items:
//   "HARDENED: ZERO-KNOWLEDGE AUDIT TRAIL ACTIVE" → no ZK implementation exists
//   "EDGE QUORUM: 7-NODE BFT"                     → no 7-node BFT signing impl
//   "DEPLOYING: AGENT SWEEP ACTIVE"               → vague aspirational copy
// Replaced with claims that DO have implementations in this codebase.
const fallbackMessages = [
  'POSTURE: POST_QUANTUM_READY_PHASE_A',
  'ATTESTOR: ED25519 SEALS LIVE · JWKS ROTATION 180D/60D',
  'LEDGER: PHASE A SEALS PUBLISHING · PHASE B SWAP IN FLIGHT',
  'SPS: 7-LENS ADVERSARIAL REVIEW · SELF-LEARNING REGRESSION LOCK',
  'EDGE: ~1,400 SOVEREIGN ZONES ON CLOUDFLARE',
  'STATUS: ALL SYSTEMS NOMINAL',
];

const StatusTicker = () => {
  const [messages, setMessages] = useState(fallbackMessages);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.status.getTicker().then((data) => {
      if (data?.messages?.length) setMessages(data.messages);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % messages.length), 4000);
    return () => clearInterval(t);
  }, [messages.length]);

  return (
    <div data-testid="status-ticker" className="fixed top-0 left-0 right-0 z-50 h-8 bg-obsidian border-b border-green/10 flex items-center justify-center overflow-hidden">
      <div className="flex items-center gap-3 font-mono text-[10px] tracking-widest uppercase">
        <PulseDot status="online" size="sm" />
        <span className="text-green/80 transition-opacity duration-base">{messages[idx]}</span>
      </div>
    </div>
  );
};

export default StatusTicker;
